import React from 'react';
import PropTypes from 'prop-types';
import './Snow.css';

const Snow = (props) => {
  const { colors } = props;
  const bg = {
    background: `radial-gradient(ellipse at bottom, ${colors[0]} 0%, ${colors[1]} 100%)`,
  };
  
  const arraySnow = Array(200).fill('snow');

  return (
    <div className="snow-block" style={bg}>
     {arraySnow.map((item, index )=> (<div className={item} key={index.toString()}/>))}
    </div>
  );
};

Snow.propTypes = {
  colors: PropTypes.array,
};

export default Snow;